import React from "react";

export default function Privacy() {
  return (
    <div className="min-h-screen bg-white">
      <header className="border-b border-neutral-200">
        <div className="max-w-[1240px] mx-auto px-5 md:px-8 h-16 flex items-center">
          <a href="/" className="flex items-center gap-2 select-none">
            <span aria-hidden className="inline-block w-1.5 h-1.5 rounded-full" style={{ background: "#c9a86a" }} />
            <span className="font-display tracking-[0.28em] text-[13px] font-medium text-neutral-950">WEDFLOW</span>
          </a>
        </div>
      </header>

      <main className="max-w-[760px] mx-auto px-5 md:px-8 py-16 md:py-24">
        <div className="text-[11px] tracking-[0.22em] uppercase text-neutral-500 mb-4">Documento legale</div>
        <h1 className="font-display text-[38px] md:text-[52px] tracking-[-0.02em] font-light text-neutral-950 leading-[1.05] mb-4">
          Privacy Policy
        </h1>
        <p className="text-[14px] text-neutral-500 mb-16">Ultimo aggiornamento: maggio 2025</p>

        <div className="prose-custom space-y-12 text-[15px] text-neutral-700 leading-relaxed">

          <section>
            <h2 className="font-display text-[22px] font-medium text-neutral-950 mb-4">1. Titolare del trattamento</h2>
            <p>Il titolare del trattamento dei dati personali è <strong>WEDFLOW</strong>, raggiungibile all'indirizzo email <a href="mailto:info@pec.wedflow.me" className="text-[#c9a86a] underline underline-offset-2">info@pec.wedflow.me</a>.</p>
          </section>

          <section>
            <h2 className="font-display text-[22px] font-medium text-neutral-950 mb-4">2. Dati raccolti</h2>
            <p>WEDFLOW raccoglie i seguenti dati personali:</p>
            <ul className="mt-4 space-y-2 list-none pl-0">
              {[
                "Dati di registrazione: nome, indirizzo email, password (in forma cifrata).",
                "Dati del profilo: informazioni sull'evento matrimoniale (data, luogo, nome degli sposi).",
                "Contenuti caricati: foto e video condivisi dagli ospiti tramite QR code.",
                "Dati di pagamento: gestiti da Stripe Inc. WEDFLOW non conserva dati della carta di credito.",
                "Dati di navigazione: indirizzo IP, browser, pagine visitate, raccolti tramite log di sistema.",
              ].map((item, i) => (
                <li key={i} className="flex gap-3">
                  <span className="mt-2 w-1 h-1 rounded-full bg-[#c9a86a] flex-none" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </section>

          <section>
            <h2 className="font-display text-[22px] font-medium text-neutral-950 mb-4">3. Finalità del trattamento</h2>
            <p>I dati sono trattati per le seguenti finalità:</p>
            <ul className="mt-4 space-y-2 list-none pl-0">
              {[
                "Fornitura del servizio: creazione e gestione dell'account, raccolta e archiviazione di foto e video.",
                "Gestione dei pagamenti: elaborazione degli abbonamenti tramite Stripe.",
                "Comunicazioni di servizio: email transazionali relative all'account e all'evento.",
                "Sicurezza: prevenzione di frodi e accessi non autorizzati.",
                "Obblighi legali: adempimento di obblighi normativi applicabili.",
              ].map((item, i) => (
                <li key={i} className="flex gap-3">
                  <span className="mt-2 w-1 h-1 rounded-full bg-[#c9a86a] flex-none" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </section>

          <section>
            <h2 className="font-display text-[22px] font-medium text-neutral-950 mb-4">4. Base giuridica</h2>
            <p>Il trattamento dei dati si fonda su: esecuzione del contratto (art. 6.1.b GDPR) per la fornitura del servizio; consenso dell'interessato (art. 6.1.a GDPR) per comunicazioni promozionali; legittimo interesse (art. 6.1.f GDPR) per la sicurezza della piattaforma.</p>
          </section>

          <section>
            <h2 className="font-display text-[22px] font-medium text-neutral-950 mb-4">5. Conservazione dei dati</h2>
            <p>I dati sono conservati per tutta la durata del rapporto contrattuale e, successivamente, per il tempo necessario ad adempiere agli obblighi legali. Le foto e i video caricati sono disponibili per la durata del piano acquistato (15 giorni per Free, 24 mesi per Smart, 36 mesi per Premium). Alla scadenza, i contenuti vengono eliminati in modo permanente.</p>
          </section>

          <section>
            <h2 className="font-display text-[22px] font-medium text-neutral-950 mb-4">6. Condivisione dei dati</h2>
            <p>WEDFLOW non vende né cede i dati personali a terzi. I dati possono essere condivisi con:</p>
            <ul className="mt-4 space-y-2 list-none pl-0">
              {[
                "Stripe Inc. — gestione dei pagamenti.",
                "Cloudinary Inc. — archiviazione di foto e video.",
                "Supabase Inc. — autenticazione degli utenti.",
                "MongoDB Atlas — database applicativo.",
              ].map((item, i) => (
                <li key={i} className="flex gap-3">
                  <span className="mt-2 w-1 h-1 rounded-full bg-[#c9a86a] flex-none" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
            <p className="mt-4">Tutti i fornitori operano in conformità al GDPR e garantiscono adeguati livelli di protezione dei dati.</p>
          </section>

          <section>
            <h2 className="font-display text-[22px] font-medium text-neutral-950 mb-4">7. Diritti dell'interessato</h2>
            <p>In qualità di interessato, hai diritto a: accedere ai tuoi dati personali; rettificarli o aggiornarli; richiederne la cancellazione; opporti al trattamento; richiedere la portabilità dei dati; revocare il consenso in qualsiasi momento.</p>
            <p className="mt-4">Per esercitare questi diritti scrivi a <a href="mailto:info@pec.wedflow.me" className="text-[#c9a86a] underline underline-offset-2">info@pec.wedflow.me</a>. Hai inoltre il diritto di proporre reclamo al Garante per la protezione dei dati personali.</p>
          </section>

          <section>
            <h2 className="font-display text-[22px] font-medium text-neutral-950 mb-4">8. Cookie</h2>
            <p>WEDFLOW utilizza esclusivamente cookie tecnici necessari al funzionamento del servizio (autenticazione, sessione). Non vengono utilizzati cookie di profilazione o di tracciamento pubblicitario.</p>
          </section>

          <section>
            <h2 className="font-display text-[22px] font-medium text-neutral-950 mb-4">9. Modifiche</h2>
            <p>WEDFLOW si riserva il diritto di aggiornare questa Privacy Policy. Le modifiche rilevanti saranno comunicate via email. L'uso continuato del servizio dopo la notifica costituisce accettazione delle modifiche.</p>
          </section>

          <section>
            <h2 className="font-display text-[22px] font-medium text-neutral-950 mb-4">10. Contatti</h2>
            <p>Per qualsiasi domanda relativa alla presente Privacy Policy: <a href="mailto:info@pec.wedflow.me" className="text-[#c9a86a] underline underline-offset-2">info@pec.wedflow.me</a></p>
          </section>

        </div>
      </main>

      <footer className="border-t border-neutral-200 mt-16">
        <div className="max-w-[1240px] mx-auto px-5 md:px-8 py-6 flex items-center justify-between text-[12px] tracking-[0.12em] uppercase text-neutral-500">
          <span>© {new Date().getFullYear()} WEDFLOW</span>
          <a href="/" className="wf-link">Torna al sito</a>
        </div>
      </footer>
    </div>
  );
}
